/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
const e = "editor.bold", t = "editor.italic", o = "editor.underline", r = "editor.strikethrough", i = "editor.subscript", l = "editor.superscript", s = "editor.hyperlink", n = "editor.insertFile", d = "editor.print", c = "editor.selectAll", a = "editor.cleanFormatting", p = "editor.pdf", b = "editor.foregroundColor", P = "editor.backgroundColor", g = "editor.createTable", C = "editor.insertTableHint", h = "editor.addRowBefore", m = "editor.addRowAfter", f = "editor.addColumnBefore", R = "editor.addColumnAfter", A = "editor.deleteRow", u = "editor.deleteColumn", y = "editor.deleteTable", T = "editor.mergeCells", S = "editor.splitCell", B = "editor.hyperlink-dialog-title", w = "editor.hyperlink-dialog-content-address", I = "editor.hyperlink-dialog-content-title", H = "editor.hyperlink-dialog-content-newwindow", k = "editor.hyperlink-dialog-cancel", W = "editor.hyperlink-dialog-insert", L = "editor.insertfile-dialog-title", v = "editor.insertfile-dialog-content-address", F = "editor.insertfile-dialog-content-title", M = "editor.insertfile-dialog-cancel", D = "editor.insertfile-dialog-insert", x = "editor.image", N = "editor.image-dialog-title", U = "editor.image-address", G = "editor.image-title", z = "editor.image-altText", E = "editor.image-width", O = "editor.image-height", J = "editor.image-cancel", V = "editor.image-insert", j = "editor.viewHtml", q = "editor.viewHtml-dialog-title", K = "editor.viewHtml-cancel", Q = "editor.viewHtml-update", X = "editor.unlink", Y = "editor.undo", Z = "editor.redo", _ = "editor.fontSize", $ = "editor.fontName", ee = "editor.format", te = "editor.alignLeft", oe = "editor.alignRight", re = "editor.alignCenter", ie = "editor.alignJustify", le = "editor.indent", se = "editor.outdent", ne = "editor.orderedList", de = "editor.bulletList", ce = "editor.findReplace-tool-title", ae = "editor.findReplace-dialog-title", pe = "editor.findReplace-tab-find", be = "editor.findReplace-tab-replace", Pe = "editor.findReplace-findWhat", ge = "editor.findReplace-replaceWith", Ce = "editor.findReplace-replace", he = "editor.findReplace-replaceAll", me = "editor.findReplace-matchCase", fe = "editor.findReplace-matchWord", Re = "editor.findReplace-matchCyclic", Ae = "editor.findReplace-useRegExp", ue = "editor.findReplace-prevMatch", ye = "editor.findReplace-nextMatch", Te = "editor.findReplace-matches", Se = "editor.iframeTitle", Be = "editorTools.foreColorLabel", we = "editorTools.backColorLabel", Ie = "editor.cellProperties", He = "editor.cellPropertiesLeftTop", ke = "editor.cellPropertiesCenterTop", We = "editor.cellPropertiesRightTop", Le = "editor.cellPropertiesLeftMiddle", ve = "editor.cellPropertiesCenterMiddle", Fe = "editor.cellPropertiesRightMiddle", Me = "editor.cellPropertiesLeftBottom", De = "editor.cellPropertiesCenterBottom", xe = "editor.cellPropertiesRightBottom", Ne = "editor.cellPropertiesNoAlignment", Ue = "editor.cellPropertiesWrap", Ge = "editor.cellPropertiesFitToCell", ze = "editor.cellPropertiesApplyToAllCells", Ee = "editor.cellPropertiesWidth", Oe = "editor.cellPropertiesApplyToColumn", Je = "editor.cellPropertiesHeight", Ve = "editor.cellPropertiesApplyToRow", je = "editor.cellPropertiesAlignment", qe = "editor.cellPropertiesTextControl", Ke = "editor.cellPropertiesCellPadding", Qe = "editor.cellPropertiesBackground", Xe = "editor.cellPropertiesBorderWidth", Ye = "editor.cellPropertiesBorderColor", Ze = "editor.cellPropertiesBorderStyle", _e = "editor.cellPropertiesId", $e = "editor.cellPropertiesCssClass", et = "editor.cellPropertiesSave", tt = "editor.cellPropertiesCancel", ot = "editor.tableProperties", rt = "editor.tablePropertiesAlignLeft", it = "editor.tablePropertiesAlignCenter", lt = "editor.tablePropertiesAlignRight", st = "editor.tablePropertiesNoAlignment", nt = "editor.tablePropertiesLeft", dt = "editor.tablePropertiesCenter", ct = "editor.tablePropertiesRight", at = "editor.tablePropertiesTop", pt = "editor.tablePropertiesBottom", bt = "editor.tablePropertiesNone", Pt = "editor.tablePropertiesUsingScopeAttribute", gt = "editor.tablePropertiesUsingIdAttributes", Ct = "editor.tablePropertiesRows", ht = "editor.tablePropertiesColumns", mt = "editor.tablePropertiesWidth", ft = "editor.tablePropertiesHeight", Rt = "editor.tablePropertiesPosition", At = "editor.tablePropertiesAlignment", ut = "editor.tablePropertiesCellSpacing", yt = "editor.tablePropertiesCellPadding", Tt = "editor.tablePropertiesTableBackground", St = "editor.tablePropertiesBorderWidth", Bt = "editor.tablePropertiesBorderColor", wt = "editor.tablePropertiesBorderStyle", It = "editor.tablePropertiesCollapseBorders", Ht = "editor.tablePropertiesID", kt = "editor.tablePropertiesCssClass", Wt = "editor.tablePropertiesAccessibility", Lt = "editor.tablePropertiesCaption", vt = "editor.tablePropertiesCaptionPosition", Ft = "editor.tablePropertiesCaptionAlignment", Mt = "editor.tablePropertiesHeaderRows", Dt = "editor.tablePropertiesHeaderCols", xt = "editor.tablePropertiesAssociateHeaders", Nt = "editor.tablePropertiesGeneral", Ut = "editor.tablePropertiesAdvanced", Gt = "editor.tablePropertiesSave", zt = "editor.tablePropertiesCancel", Et = "editor.borderStyleNone", Ot = "editor.borderStyleSolid", Jt = "editor.borderStyleDotted", Vt = "editor.borderStyleDashed", jt = "editor.borderStyleDouble", qt = "editor.borderStyleGroove", Kt = "editor.borderStyleRidge", Qt = "editor.borderStyleInset", Xt = "editor.borderStyleOutset", Yt = "editor.borderStyleInitial", Zt = "editor.borderStyleInherit", _t = "editor.borderStyleHidden", $t = "editor.sizeAuto", eo = {
  [e]: "Bold",
  [t]: "Italic",
  [o]: "Underline",
  [r]: "Strikethrough",
  [i]: "Subscript",
  [l]: "Superscript",
  [X]: "Remove hyperlink",
  [Y]: "Undo",
  [Z]: "Redo",
  [_]: "Font Size",
  [$]: "Font Name",
  [ee]: "Format",
  [te]: "Align text left",
  [oe]: "Align text right",
  [re]: "Center text",
  [ie]: "Justify",
  [le]: "Indent",
  [se]: "Outdent",
  [ne]: "Insert ordered list",
  [de]: "Insert unordered list",
  [d]: "Print",
  [c]: "Select All",
  [a]: "Clean formatting",
  [p]: "Export as PDF",
  [b]: "Color",
  [P]: "Background color",
  // Tables
  [g]: "Create a table",
  [C]: "Create a {0} x {1} table",
  [h]: "Add row above",
  [m]: "Add row below",
  [f]: "Add column on the left",
  [R]: "Add column on the right",
  [A]: "Delete row",
  [u]: "Delete column",
  [y]: "Delete table",
  [T]: "Merge cells",
  [S]: "Split cell",
  // Insert Link
  [s]: "Insert hyperlink",
  [B]: "Insert hyperlink",
  [w]: "Web address",
  [I]: "Title",
  [H]: "Open link in new window",
  [k]: "Cancel",
  [W]: "Insert",
  // Insert File
  [n]: "Insert file",
  [L]: "Insert file",
  [v]: "Web address",
  [F]: "Title",
  [M]: "Cancel",
  [D]: "Insert",
  // Insert Image
  [x]: "Insert image",
  [N]: "Insert image",
  [U]: "Web address",
  [G]: "Title",
  [z]: "Alternate text",
  [E]: "Width (px)",
  [O]: "Height (px)",
  [J]: "Cancel",
  [V]: "Insert",
  // View HTML
  [j]: "View HTML",
  [q]: "View HTML",
  [K]: "Cancel",
  [Q]: "Update",
  // Find and Replace
  [ce]: "Find and Replace",
  [ae]: "Find and Replace",
  [pe]: "Find",
  [be]: "Replace",
  [Pe]: "Find What:",
  [ge]: "Replace With",
  [Ce]: "Replace",
  [he]: "Replace All",
  [me]: "Match Case",
  [fe]: "Match whole word only",
  [Re]: "Match cyclic (Wrap around)",
  [Ae]: "Regular Expression",
  [ue]: "Prev",
  [ye]: "Next",
  [Te]: "{0} of {1} matches",
  [Se]: "Editable area. Press Alt + F10 for toolbar.",
  [Be]: "Fore Color",
  [we]: "Back Color",
  [Ie]: "Cell properties",
  [He]: "Left Top",
  [ke]: "Center Top",
  [We]: "Right Top",
  [Le]: "Left Middle",
  [ve]: "Center Middle",
  [Fe]: "Right Middle",
  [Me]: "Left Bottom",
  [De]: "Center Bottom",
  [xe]: "Right Bottom",
  [Ne]: "No Alignment",
  [Ue]: "Wrap",
  [Ge]: "Fit to cell",
  [ze]: "Apply to all cells",
  [Ee]: "Width",
  [Oe]: "apply to column",
  [Je]: "Height",
  [Ve]: "apply to row",
  [je]: "Alignment",
  [qe]: "Text control",
  [Ke]: "Cell padding",
  [Qe]: "Background",
  [Xe]: "Border width",
  [Ye]: "Border color",
  [Ze]: "Border style",
  [_e]: "ID",
  [$e]: "CSS class",
  [et]: "Save",
  [tt]: "Cancel",
  [ot]: "Table properties",
  [rt]: "Align Left",
  [it]: "Align Center",
  [lt]: "Align Right",
  [st]: "No Alignment",
  [nt]: "Left",
  [dt]: "Center",
  [ct]: "Right",
  [at]: "Top",
  [pt]: "Bottom",
  [bt]: "None",
  // eslint-disable-next-line @typescript-eslint/quotes
  [Pt]: "Using 'scope' attribute",
  // eslint-disable-next-line @typescript-eslint/quotes
  [gt]: "Using 'id' attributes",
  [Ct]: "Rows",
  [ht]: "Columns",
  [mt]: "Width",
  [ft]: "Height",
  [Rt]: "Position",
  [At]: "Alignment",
  [ut]: "Cell spacing",
  [yt]: "Cell padding",
  [Tt]: "Table background",
  [St]: "Border width",
  [Bt]: "Border color",
  [wt]: "Border style",
  [It]: "Collapse borders",
  [Ht]: "ID",
  [kt]: "CSS class",
  [Wt]: "Accessibility",
  [Lt]: "Caption",
  [vt]: "Position",
  [Ft]: "Alignment",
  [Mt]: "Header rows",
  [Dt]: "Header cols",
  [xt]: "Associate headers",
  [Nt]: "General",
  [Ut]: "Advanced",
  [Gt]: "Save",
  [zt]: "Cancel",
  [Et]: "None",
  [Ot]: "Solid",
  [Jt]: "Dotted",
  [Vt]: "Dashed",
  [jt]: "Double",
  [qt]: "Groove",
  [Kt]: "Ridge",
  [Qt]: "Inset",
  [Xt]: "Outset",
  [Yt]: "Initial",
  [Zt]: "Inherit",
  [_t]: "Hidden",
  [$t]: "Auto"
}, to = {
  bold: e,
  italic: t,
  underline: o,
  strikethrough: r,
  subscript: i,
  superscript: l,
  unlink: X,
  undo: Y,
  redo: Z,
  fontSize: _,
  fontName: $,
  format: ee,
  alignLeft: te,
  alignRight: oe,
  alignCenter: re,
  alignJustify: ie,
  indent: le,
  outdent: se,
  orderedList: ne,
  bulletList: de,
  print: d,
  selectAll: c,
  cleanFormatting: a,
  pdf: p,
  foregroundColor: b,
  backgroundColor: P,
  createTable: g,
  createTableHint: C,
  addRowBefore: h,
  addRowAfter: m,
  addColumnBefore: f,
  addColumnAfter: R,
  deleteRow: A,
  deleteColumn: u,
  deleteTable: y,
  mergeCells: T,
  splitCell: S,
  insertHyperlink: s,
  insertHyperlinkDialogTitle: B,
  insertHyperlinkAddress: w,
  insertHyperlinkTitle: I,
  insertHyperlinkNewWindow: H,
  insertHyperlinkCancel: k,
  insertHyperlinkInsert: W,
  insertFile: n,
  insertFileDialogTitle: L,
  insertFileAddress: v,
  insertFileTitle: F,
  insertFileCancel: M,
  insertFileInsert: D,
  insertImage: x,
  insertImageDialogTitle: N,
  insertImageAddress: U,
  insertImageTitle: G,
  insertImageAltText: z,
  insertImageWidth: E,
  insertImageHeight: O,
  insertImageCancel: J,
  insertImageInsert: V,
  viewHtml: j,
  viewHtmlDialogTitle: q,
  viewHtmlCancel: K,
  viewHtmlUpdate: Q,
  findReplaceToolTitle: ce,
  findReplaceDialogTitle: ae,
  findReplaceTabFind: pe,
  findReplaceTabReplace: be,
  findReplaceFindWhat: Pe,
  findReplaceReplaceWith: ge,
  findReplaceReplace: Ce,
  findReplaceReplaceAll: he,
  findReplaceMatchCase: me,
  findReplaceMatchWord: fe,
  findReplaceMatchCyclic: Re,
  findReplaceUseRegExp: Ae,
  findReplacePrevMatch: ue,
  findReplaceNextMatch: ye,
  findReplaceMatches: Te,
  iframeTitle: Se,
  foreColorLabel: Be,
  backColorLabel: we,
  cellProperties: Ie,
  cellPropertiesLeftTop: He,
  cellPropertiesCenterTop: ke,
  cellPropertiesRightTop: We,
  cellPropertiesLeftMiddle: Le,
  cellPropertiesCenterMiddle: ve,
  cellPropertiesRightMiddle: Fe,
  cellPropertiesLeftBottom: Me,
  cellPropertiesCenterBottom: De,
  cellPropertiesRightBottom: xe,
  cellPropertiesNoAlignment: Ne,
  cellPropertiesWrap: Ue,
  cellPropertiesFitToCell: Ge,
  cellPropertiesApplyToAllCells: ze,
  cellPropertiesWidth: Ee,
  cellPropertiesApplyToColumn: Oe,
  cellPropertiesHeight: Je,
  cellPropertiesApplyToRow: Ve,
  cellPropertiesAlignment: je,
  cellPropertiesTextControl: qe,
  cellPropertiesCellPadding: Ke,
  cellPropertiesBackground: Qe,
  cellPropertiesBorderWidth: Xe,
  cellPropertiesBorderColor: Ye,
  cellPropertiesBorderStyle: Ze,
  cellPropertiesId: _e,
  cellPropertiesCssClass: $e,
  cellPropertiesSave: et,
  cellPropertiesCancel: tt,
  tableProperties: ot,
  tablePropertiesAlignLeft: rt,
  tablePropertiesAlignCenter: it,
  tablePropertiesAlignRight: lt,
  tablePropertiesNoAlignment: st,
  tablePropertiesLeft: nt,
  tablePropertiesCenter: dt,
  tablePropertiesRight: ct,
  tablePropertiesTop: at,
  tablePropertiesBottom: pt,
  tablePropertiesNone: bt,
  tablePropertiesUsingScopeAttribute: Pt,
  tablePropertiesUsingIdAttributes: gt,
  tablePropertiesRows: Ct,
  tablePropertiesColumns: ht,
  tablePropertiesWidth: mt,
  tablePropertiesHeight: ft,
  tablePropertiesPosition: Rt,
  tablePropertiesAlignment: At,
  tablePropertiesCellSpacing: ut,
  tablePropertiesCellPadding: yt,
  tablePropertiesTableBackground: Tt,
  tablePropertiesBorderWidth: St,
  tablePropertiesBorderColor: Bt,
  tablePropertiesBorderStyle: wt,
  tablePropertiesCollapseBorders: It,
  tablePropertiesId: Ht,
  tablePropertiesCssClass: kt,
  tablePropertiesAccessibility: Wt,
  tablePropertiesCaption: Lt,
  tablePropertiesCaptionPosition: vt,
  tablePropertiesCaptionAlignment: Ft,
  tablePropertiesHeaderRows: Mt,
  tablePropertiesHeaderCols: Dt,
  tablePropertiesAssociateHeaders: xt,
  tablePropertiesGeneral: Nt,
  tablePropertiesAdvanced: Ut,
  tablePropertiesSave: Gt,
  tablePropertiesCancel: zt,
  borderStyleNone: Et,
  borderStyleSolid: Ot,
  borderStyleDotted: Jt,
  borderStyleDashed: Vt,
  borderStyleDouble: jt,
  borderStyleGroove: qt,
  borderStyleRidge: Kt,
  borderStyleInset: Qt,
  borderStyleOutset: Xt,
  borderStyleInitial: Yt,
  borderStyleInherit: Zt,
  borderStyleHidden: _t,
  sizeAuto: $t
};
export {
  to as keys,
  eo as messages
};
